export default __webpack_public_path__ + "static/ost-0292715bbfbf59f643b214a6ade944fd.mp3";